import { render, staticRenderFns } from "./EditingTranslation.vue?vue&type=template&id=2b5c9e3d&"
import script from "./EditingTranslation.vue?vue&type=script&lang=js&"
export * from "./EditingTranslation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports